import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

export interface FeatureFlagDto {
  key: string;
  value: string;
  label: string | null;
  lastModified: string | null;
  contentType: string | null;
}

@Injectable({ providedIn: 'root' })
export class FeatureFlagService {
  constructor(private readonly httpClient: HttpClient) {}

  getFlags(baseUrl: string): Promise<FeatureFlagDto[]> {
    return firstValueFrom(
      this.httpClient.get<FeatureFlagDto[]>(`${baseUrl.replace(/\/$/, '')}/featureflags`)
    );
  }

  patchFlag(baseUrl: string, featureName: string, value: string, label: string | null = null): Promise<void> {
    return firstValueFrom(
      this.httpClient.patch<void>(
        `${baseUrl.replace(/\/$/, '')}/featureflags/${encodeURIComponent(featureName)}`,
        { key: featureName, value, label }
      )
    );
  }
}
